import React, { useState, useEffect } from "react";
import {
  Col,
  FormGroup,
  Input,
  Row,
  Button,
  Container,
  Card,
  CardBody,
} from "reactstrap";
import { FiTrash2 } from "react-icons/fi";
import AdjuntosOrdenEdicion from "./AdjuntoOrdenEdicion";

const EditaAnexosOrden = (props) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [documentOptions, setDocumentOptions] = useState([]);

  useEffect(() => {
    fetch(
      "https://inspecciongnvback-dev.azurewebsites.net/api/v1/ObtenerPropietariosPorVehiculo/" +
        props.idOrden,
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.length > 0) {
          setData(data[0]);
        } else {
          setError(new Error("No data found"));
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setError(error);
        setLoading(false);
      });
  }, [props.idOrden]);

  useEffect(() => {
    if (data) {
      fetch(
        "https://inspecciongnvback-dev.azurewebsites.net/api/v1/ObtenerListaDocumentos/" +
          data.tipoOrdenServicioId,
      )
        .then((response) => response.json())
        .then((data) => setDocumentOptions(data))
        .catch((error) =>
          console.error("Error fetching document options:", error),
        );
    }
  }, [data]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const id = parseInt(e.target.dataset.id);

    setData((prevData) => ({
      ...prevData,
      anexos: prevData.anexos.map((anexo) =>
        anexo.id === id ? { ...anexo, [name]: value } : anexo,
      ),
    }));
  };

  const handleDelete = (id, archivo) => {
    fetch(
      `https://inspecciongnvback-dev.azurewebsites.net/api/v1/EliminaAnexo/${id}/${archivo}`,
      {
        method: "DELETE",
      },
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error("Error eliminando el anexo");
        }
        setData((prevData) => ({
          ...prevData,
          anexos: prevData.anexos.filter((anexo) => anexo.id !== id),
        }));
      })
      .catch((error) => {
        console.error("Error deleting anexo:", error);
        alert("Error eliminando el anexo");
      });
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error.message}</div>;

  return (
    <Container className="mt--1" fluid>
      <Card className="shadow">
        <CardBody>
          <Row>
            <Col>
              <h3>Anexos</h3>
              {data && data.anexos && data.anexos.length > 0 ? (
                data.anexos.map((anexo, index) => (
                  <Row key={index}>
                    <Col lg="5">
                      <FormGroup>
                        <label
                          className="form-control-label"
                          htmlFor={`input-url-${index}`}
                        >
                          Documento Anexo
                        </label>
                        <br></br>
                        <a href={anexo.url} target="_blank">
                          Descargar Archivo Anexo
                        </a>
                      </FormGroup>
                    </Col>
                    <Col lg="5">
                      <FormGroup>
                        <label
                          className="form-control-label"
                          htmlFor={`input-anexoId-${index}`}
                        >
                          Documento
                        </label>
                        <Input
                          className="form-control-alternative"
                          type="select"
                          name="anexoId"
                          data-id={anexo.id}
                          value={anexo.anexoId}
                          onChange={handleChange}
                          disabled
                        >
                          <option value="">Seleccione un documento</option>
                          {documentOptions.map((option) => (
                            <option key={option.id} value={option.id}>
                              {option.adjunto}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>
                    </Col>
                    <Col lg="2" className="d-flex align-items-center">
                      <Button
                        color="danger"
                        onClick={() => handleDelete(anexo.id, anexo.archivo)}
                      >
                        <FiTrash2 />
                      </Button>
                    </Col>
                  </Row>
                ))
              ) : (
                <div>No hay anexos disponibles</div>
              )}
            </Col>
          </Row>

          <AdjuntosOrdenEdicion
            tipoOrden={data.tipoOrdenServicioId}
            ordenId={data.id}
          />
        </CardBody>
      </Card>
    </Container>
  );
};

export default EditaAnexosOrden;
